import { LockedNotice } from "../shared/LockedNotice";

export const BrandModeLockedNotice = () => {
  return (
    <LockedNotice>Switch to featured brand mode to customize</LockedNotice>
  );
};
